import FormFieldViewText from "components/FormFields/ViewText";
import FormField from "ds/components/Form/Field";
import SecretFieldDetails from "ds/components/SecretFieldDetails";
import { AzureDevOpsRepoIntegration } from "types/generated";

import { VCSCheckLabels } from "./helpers";
import VCSIntegrationsUseGitCheckoutInfo from "./UseGitCheckoutInfo";
type VCSIntegrationsDetailsAzureDevOpsProps = {
  details: AzureDevOpsRepoIntegration;
};

const VCSIntegrationsDetailsAzureDevOps = ({ details }: VCSIntegrationsDetailsAzureDevOpsProps) => {
  return (
    <>
      <FormFieldViewText label="Organization URL" value={details.organizationURL} />

      <FormFieldViewText label="User facing host URL" value={details.userFacingHost} />

      <FormField label="Webhook secret">
        <SecretFieldDetails secret={details.webhookPassword} />
      </FormField>

      <FormFieldViewText
        label="Webhook endpoint"
        value={details.webhookUrl}
        withCopy
        noTextEllipsis
        textWordBreak
      />

      <VCSIntegrationsUseGitCheckoutInfo value={details.useGitCheckout} />

      <FormFieldViewText label="VCS checks" value={VCSCheckLabels[details.vcsChecks]} />
    </>
  );
};

export default VCSIntegrationsDetailsAzureDevOps;
